module.exports = __webpack_public_path__ + "img/2.8ce192e8.png";